import styled from 'styled-components';

export const CommonPageStyled = styled.div`
  background-color: ${props => props.theme.colors.additionalBackgroundWhite};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.colors.white};
  align-items: center;
  color: ${props => props.theme.colors.additionalText};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  border-radius: 16px;
  flex-grow: 1;
`;

export const CommonPageHeaderStyled = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 32px;
`;

export const CommonPageHeaderProgressBarStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  p {
    margin: 0 0 8px;
    color: ${props => props.theme.colors.additionalText};
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
  }
`;

export const CommonPageHeaderMobileStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
  align-items: center;
  
  p {
    margin: 0;
    color: ${props => props.theme.colors.additionalText};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0;
    text-align: center;
  }
  button {
    margin: 0;
  }
`;
